export default __webpack_public_path__ + "static/media/swedish_krona_green-sign.e6811974.svg";